export default __webpack_public_path__ + "static/media/LogoFecoer.f36ce5ff.png";